import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useGetBilledRecipientsQuery } from 'app/features/mail/api/mailApi';

import {
  Grid,
  Pagination,
  PaginationItem,
  Stack,
} from '@mui/material';

import BilledRecipient from 'app/features/mail/components/message_details/BilledRecipient';
import FullHeightLoadingSpinner from 'app/features/mail/components/FullHeightLoadingSpinner';

const BilledRecipientList = ({ messageId }) => {
  const [page, setPage] = useState(1);

  const {
    data: billedRecipients,
    isLoading,
  } = useGetBilledRecipientsQuery({ messageId, page });

  const handlePageChange = (_event, value) => {
    setPage(value);
  };

  return (
    <Stack
      direction="column"
      spacing={2}
    >
      <Grid
        container
        direction="row"
        borderBottom="1px solid #ddd"
      >
        <Grid
          item
          xs={6}
        >
          Recipients (
          {billedRecipients && billedRecipients.recipients.length}
          )
        </Grid>
        <Grid
          item
          xs={6}
        >
          Payment Status
        </Grid>
      </Grid>

      {isLoading && <FullHeightLoadingSpinner /> }
      {billedRecipients && (
        <Stack
          direction="column"
          spacing={2}
        >
          {billedRecipients.recipients.map((recipient) => (
            <BilledRecipient
              key={recipient.id}
              recipient={recipient}
            />
          ))}
        </Stack>
      )}
      { billedRecipients && billedRecipients.pagination && (
        <Pagination
          sx={{
            display: 'flex',
            maxWidth: '100%',
            width: 'auto',
            marginX: '10px',
            height: 'auto',
            border: 'none',
          }}
          siblingCount={0}
          count={billedRecipients.pagination.totalPages || 1}
          page={page}
          onChange={handlePageChange}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              sx={{
                borderRadius: '4px',
                margin: '0 3px',
                '& .MuiSvgIcon-root': {
                  fontSize: '3em',
                },
              }}
            />
          )}
        />
      )}
    </Stack>
  );
};

BilledRecipientList.defaultProps = {
};

BilledRecipientList.propTypes = {
  messageId: PropTypes.number.isRequired,
};

export default BilledRecipientList;
